export interface PageParams {
	country: string
	language: string
}

export interface PageProps {
	params: Promise<PageParams>
}

export const defaultParams = {
	country: 'gb',
	language: 'en',
}
